export const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Season 1', to: '/season-1/' },
  { label: 'Season 2', to: '/season-2/' },
  { label: 'News', to: '/updates/' },
  { label: 'Game', to: '/game/' },
  { label: 'Comic Book', to: '/spectrum-comic-book/' },
  { label: 'Press', to: '/press/' },
  { label: 'FAQ', to: '/faq/' },
] as const
